var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7598 8.94922C10.7598 8.77995 10.7272 8.6237 10.6621 8.48047C10.597 8.33724 10.4993 8.20052 10.3691 8.07031L2.76172 0.628906C2.54688 0.414062 2.27995 0.306641 1.96094 0.306641C1.7526 0.306641 1.56055 0.358724 1.38477 0.462891C1.20898 0.560547 1.06901 0.69401 0.964844 0.863281C0.867188 1.03255 0.818359 1.22461 0.818359 1.43945C0.818359 1.74544 0.935547 2.01888 1.16992 2.25977L8.02539 8.94922L1.16992 15.6387C0.935547 15.8796 0.818359 16.1562 0.818359 16.4688C0.818359 16.6771 0.867188 16.8659 0.964844 17.0352C1.06901 17.2109 1.20898 17.3477 1.38477 17.4453C1.56055 17.5495 1.7526 17.6016 1.96094 17.6016C2.27995 17.6016 2.54688 17.4909 2.76172 17.2695L10.3691 9.82812C10.4993 9.69792 10.597 9.5612 10.6621 9.41797C10.7272 9.27474 10.7598 9.11849 10.7598 8.94922Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.34d99a52eda3184f07a258ac1b879872.svg";
export { ForwardRef as ReactComponent };